<template>
  <v-chip v-text="title" :color="color" dark v-bind="$attrs"></v-chip>
</template>

<script>
import i18n from "@/mixins/i18n";
export default {
  mixins: [i18n],
  props: {
    status: String,
  },

  computed: {
    color() {
      switch (this.status) {
        case "pending":
          return "info";
        case "failure":
        case "canceled":
          return "red";
        case "concluded":
          return "green";
        case "letter":
          return "grey";
        case "refused":
          return "red";
        default:
          return "grey";
      }
    },
    title() {
      switch (this.status) {
        case "pending":
          return this.__("em agendamento", "schedulings");
        case "failure":
          return this.__("insucesso", "schedulings");
        case "canceled":
          return this.__("cancelado", "schedulings");
        case "concluded":
          return this.__("concluído", "schedulings");
        case "letter":
          return this.__("carta", "schedulings");
        case "refused":
          return this.__("recusado", "schedulings");
        default:
          return this.__("desconhecido", "schedulings");
      }
    },
  },
};
</script>
